import style from "./../../ClientBook.module.scss";
import moment from "moment";
import { useEffect, useState } from "react";
import DateSelection from "../../UI/DateSelection/DateSelection";
import OptionsSelection from "./../../UI/OptionsSelection/OptionsSelection";
import api from "helpers/api";
import Loader from "components/miscellaneous/Loader/Loader";

const ModifyBooking = ({ clinic, appointment, payload }) => {
    const [ changeDate, setChangeDate ] = useState(false);
    const [ deleteAppointment, setDeleteAppointment ] = useState(false);
    const [ finished, setFinished ] = useState(false);
    const [ selectedDate, setSelectedDate ] = useState(moment(appointment.scheduled_at));
    const [ selectedStaff, setSelectedStaff ] = useState({
        id: payload.staff,
        label: payload.staffName !== null ? payload.staffName : 'Undefined'
    });
    const [ isLoading, setIsLoading ] = useState(false);
    const { services, staff } = clinic;

    const checkAvailableTimes = async (dateRange) => {
        try {
            const res = await api.get(`/booking/verify/dates/${clinic.id}`, {
                'start_date': dateRange.start,
                'end_date': dateRange.end,
                'staff_id': selectedStaff.id,
                'booking_id': appointment.id
            })

            if (res.success && res.data.success) {
                return res.data.data;
            }
        } catch (e) {

        } finally {
        }

        return null;
    }

    const updateAppointment = async () => {
        setIsLoading(true);
        if (changeDate) {
            await updateAppointmentDate()
        } else {
            await cancelAppointment();
        }

        setIsLoading(false)

        setFinished(changeDate ? 'date' : 'cancel')
    }

    const updateAppointmentDate = async () => {
        try {
            await api.patch(`/booking/${appointment.token}`, {
                scheduled_at: selectedDate.format('YYYY-MM-DD HH:mm:ss')
            });
        } catch (e) {

        }
    }

    const cancelAppointment = async () => {
        try {
            await api.delete(`/booking/${appointment.token}`);
        } catch (e) {

        }
    }

    return (
        <>
            <div className={ [ style.header, style.headerCenter ].join(' ') }>
                <h1>{ clinic.name }</h1>
                <p>Change your appointment</p>
            </div>
            <div className={ style.step } style={ { margin: 0 } }>
                <div className={ style.stepContent }>
                    <div className={ [ style.stepHeader, style.contentCenter ].join(' ') }>
                        <div className={ style.modify }>
                            { isLoading &&
                                <div className={ style.loading }>
                                    <Loader color="#ddd" />
                                </div> }
                            <>
                                { finished === false ? <>{ changeDate === false && deleteAppointment === false ? <>
                                    <h3>Hey { appointment.customer_first_name },</h3>
                                    <h3 style={ { margin: 0, fontWeight: 400 } }>Your appointment is scheduled at </h3>
                                    <h3 style={ { margin: 0, fontWeight: 400 } }>{ moment(payload.date).format('MMMM DD, YYYY') } <b>{ moment(payload.date).format('HH:00') }</b></h3>

                                    <div className={ style.modifyButtons }>
                                        <button onClick={ (e) => {
                                            setChangeDate(true)
                                        } }>Change to Different Date</button>
                                        <button onClick={ (e) => {
                                            setDeleteAppointment(true)
                                        } }>Cancel Appointment</button>
                                    </div>
                                </> : <>
                                    { changeDate === true ? <>
                                        <h3 style={ { margin: 0 } }>Change Apppointment Date</h3>
                                        <p style={ { marginTop: 0 } }>Select a new date & time from the selection below</p>

                                        <DateSelection dailyWorkingHoursRange={ clinic.working_hours } label={ "Choose date & time" } dateValue={ appointment.scheduled_at } useDefaultTime={ true } checkAvailableTimes={ checkAvailableTimes } staffId={selectedStaff.id} onChange={ setSelectedDate } maxHeight={ 200 } />

                                        <div style={ { marginTop: 20 } } className="d-flex justify-content-center">
                                            <button className="white-button" onClick={ (e) => {
                                                setChangeDate(false)
                                            } }>Cancel</button>
                                            <button onClick={ (e) => {
                                                updateAppointment()
                                            } } disabled={ selectedDate === null } className="alma-button">Save Changes</button>
                                        </div>
                                    </> : <>
                                        <b>
                                            <h3>Cancel your Appointment?</h3>
                                            <p style={ { marginTop: 0 } }>Are you sure you want to cancel your appointment?</p>
                                        </b>

                                        <div style={ { marginTop: 20 } } className="d-flex justify-content-center">
                                            <button className="white-button" onClick={ (e) => {
                                                setDeleteAppointment(false)
                                            } }>No, take me back</button>
                                            <button onClick={ (e) => {
                                                updateAppointment()
                                            } } className="alma-button">Yes, Cancel My Appointment</button>
                                        </div>
                                    </> }
                                </> }</> : <>
                                    { finished === 'date' ? <>
                                        <h3>Your appointment has been updated</h3>
                                        <p style={ { marginTop: 0 } }>Your appointment has been updated to { moment(selectedDate).format('MMMM DD, YYYY') } <b>{ moment(selectedDate).format('HH:00') }</b></p> </> : <>
                                        <h3>Your appointment has been cancelled</h3>
                                        <p style={ { marginTop: 0 } }>Your appointment has been cancelled</p>
                                    </> }
                                </> }
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModifyBooking;